import { Clipboard } from '@angular/cdk/clipboard';
import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotPassword, defaultForgotPasswordValues } from 'src/app/components/users/forgot-password';
import { ForgotPasswordService as ForgotPasswordService } from 'src/app/services/forgot-password.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent {
	errorDivVisible: boolean = false;
	inputVisible: boolean = true;
	forgotPasswordObj: ForgotPassword = defaultForgotPasswordValues();
	usertype: string = "";
	showbbApp=true;

	constructor(private _forgotPasswordService: ForgotPasswordService, private _route: ActivatedRoute, private location: Location,private clipboard:Clipboard) { }

	ngOnInit(): void {

		this._route.params.subscribe(params => {
			this.usertype = params['usertype']

			switch (this.usertype) {
				case "bbapp":
					this.showbbApp = true
					break;

				case "lltf":
					this.showbbApp = false
					break;

				default:
					this.showbbApp = true;
			}
		})
	}

	forgotPassword(fpForm: NgForm): void {
		if (fpForm.invalid) {
			return;
		}
		this.forgotPasswordObj.appType=this.usertype;
		this._forgotPasswordService.forgotpassword(this.forgotPasswordObj).subscribe((res) => {
			this.errorDivVisible = true;
			this.inputVisible = false;

      if (res) {
			  this.forgotPasswordObj.forgotPasswordGuid = res.forgotPasswordGuid
      }
		})
	}


	goBack(): void {
		this.location.back();
	}

	convertEmail(email: string): string {

		const [localPart, domainPart] = email.split('@');
		const maskedLocal = localPart.charAt(0) + '****';
	  	const maskedDomain = domainPart.charAt(0) + '****';
	  	return `${maskedLocal}@${maskedDomain}`;
	  }

}
